import Divider from 'components/shared/Divider/Divider';
import Skeleton from 'components/shared/Skeleton/Skeleton';

const Section = ({ children }) => <div className="flex w-full flex-col gap-2">{children}</div>;

const PaymentProgramSkeleton = () => {
  return (
    <div className="flex w-full max-w-[856px] flex-1 gap-2 px-4 pb-5 pt-4">
      <div className="flex flex-1 flex-col gap-6 rounded-lg px-4 py-5">
        <Section>
          <Skeleton width="40%" height={22} />
          <Skeleton count={2} height={14} />
        </Section>

        <Section>
          <Skeleton width="30%" height={16} />
          <Skeleton count={2} height={56} />
          <Skeleton height={64} />
        </Section>

        <Divider />

        <Section>
          <Skeleton width="50%" height={16} />
          <div className="flex items-center gap-2.5">
            <Skeleton width={96} height={36} containerClassName="shrink-0" />
            <div className="flex-1">
              <Skeleton height={8} />
            </div>
          </div>
          <Skeleton width="40%" height={14} />
          <Skeleton height={58} />
        </Section>

        <Divider />

        <Section>
          <Skeleton width="35%" height={18} />
          <Skeleton count={2} height={14} />
          <div className="flex flex-col gap-3 pt-2">
            <Skeleton height={48} />
            <Skeleton height={48} />
          </div>
        </Section>

        <Divider />

        <Section>
          <Skeleton width="60%" height={22} />
          <Skeleton count={2} height={14} />
          <Skeleton height={40} />
          <div className="flex flex-col gap-3 pt-2">
            <Skeleton count={3} height={56} />
          </div>
        </Section>
      </div>
    </div>
  );
};

export default PaymentProgramSkeleton;
